var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeeIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.79,
    height: 30.79,
    viewBox: "0 0 30.79 30.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-person",
    "data-name": "Icon ionic-md-person",
    d: "M19.9,19.9a7.7,7.7,0,1,0-7.7-7.7A7.72,7.72,0,0,0,19.9,19.9Zm0,3.849c-5.1,0-15.4,2.6-15.4,7.7V35.29H35.29V31.441C35.29,26.342,24.994,23.744,19.9,23.744Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#d5d5d5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIconGray);
export default __webpack_public_path__ + "static/media/EmployeeIconGray.76dc01397df299301e99790b7078e68e.svg";
export { ForwardRef as ReactComponent };